// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2suLE","footer":"ModalFilter_footer__1nU0m"};